import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientName: {
      validations: [
        { type: 'required', message: 'Your client name is required.' }
      ]
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Your first name is required.' }
      ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Your last name is required.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Your phone number is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Your email is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please select at least one venue.' }
      ]
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    accountExtra1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    accountExtra2: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    accountExtra3: {
      validations: [
        { type: 'required', message: 'Please indicate your preferred date.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    accountExtra4: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    accountExtra6: {
      validations: []
    },
    accountExtra5: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'CLIENT NAME *',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'FIRST NAME *',
            mapping: 'firstname'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'LAST NAME *',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL *',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'EVENT TYPE *',
            options: [
              { label: 'Weddings' , value: 'Weddings'},
              { label: 'Corporate Meeting or Seminar', value: 'Corporate Meeting or Seminar'},
              { label: 'Event Reception / Dinner', value: 'Event Reception / Dinner'},
              { label: 'Private Celebration', value: 'Private Celebration'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'accountExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'VENUE *',
            options: [
              { label: 'William Aiken House' , value: 'William Aiken House'},
              { label: 'American Theater', value: 'American Theater'},
              { label: 'Lowndes Grove', value: 'Lowndes Grove'},
              { label: 'River House at Lowndes Grove', value: 'River House at Lowndes Grove'},
              { label: 'Parcel 32', value: 'Parcel 32'},
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'PREFERRED DATE *',
            mapping: 'accountExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NO. OF GUESTS *',
            mapping: 'accountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'IS YOUR DATE FLEXIBLE? *',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'}
            ],
            mapping: 'accountExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Are you interested in Peninsula Events planning services?',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'}
            ],
            mapping: 'accountExtra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'COMMENTS *',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Large',
            options: [
              { label: 'Receive planning tips, news from PPHG & fresh ideas to inspire your Charleston wedding, business gathering or special event.' , value: 'Receive planning tips'}
            ],
            mapping: 'accountExtra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'Small',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Patrick Properties Event Contact Us',
    formId: '2109',
    clientKey: '3CC6874D-4537-4C03-BED6-654A2D058B98',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.pphgcharleston.com/thank-you/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
